module.exports = __webpack_public_path__ + "img/vip_bg01.f5d45454.png";